import gsap, { Power3 } from 'gsap';

import { GetBy } from '../_app/cuchillo/core/Element';
import _Header from '../_app/cuchillo/layout/Header';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Basics, isMobile } from '../_app/cuchillo/core/Basics';
import Sidemenu from './Sidemenu';

export default class Header extends _Header {
  static btn = GetBy.class('logo', this.container)[0];
  static text = GetBy.class('text', this.container)[0];
  static navOpen = false;
  static footer = GetBy.id('Footer');
  static gui = GetBy.id('Gui');
  static logo = GetBy.id('LogoBg');

  static sizes = {
    closed: { x: 0, y: 0 },
    hover: { x: 0, y: 0 },
    opened: { x: 0, y: 0 }
  }

  static options = {
    show: {
      duration: 1,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static show() {
    this.show__effect();
  }

  static showOpen() {
    this.show__effect();
    gsap.delayedCall(1.25, () => {
      this.openNav();
    })
  }

  static show__effect() {
    gsap.to(this.container, { ...this.options.show, opacity: 1 });
    gsap.to(this.footer, { ...this.options.show, opacity: 1 });
    gsap.to(this.gui, { ...this.options.show, opacity: 1 });
    gsap.to(this.logo, {
      ...this.options.show, delay: .25, opacity: 1, onComplete: () => {
      }
    });
  }

  static hide__effect() { }

  static init() {
    super.init();

    this.gui.style.opacity = '0';
    this.footer.style.opacity = '0';
    this.container.style.opacity = '0';
    this.logo.style.opacity = '0';

    this.btn.addEventListener(Basics.mouseOver, () => {
      gsap.killTweensOf(this.container);
      gsap.to(this.container, {
        width: this.sizes.hover.x,
        height: this.sizes.hover.y,
        duration: .2,
        ease: Power3.easeOut
      });

      this.container.classList.add('--hover');

      if (!isMobile) {
        gsap.set(this.text, { y: '-20%' });
        gsap.set(this.text, { y: 0, delay: .08 });
      }
    });

    this.btn.addEventListener(Basics.mouseOut, () => {
      this.container.classList.remove('--hover');

      if (!isMobile) gsap.set(this.text, { y: '-20%', delay: .18 });

      if (this.navOpen) return;
      gsap.killTweensOf(this.container);
      gsap.to(this.container, {
        width: this.sizes.closed.x,
        height: this.sizes.closed.y,
        duration: .1,
        ease: Power3.easeOut
      });

    });
  }

  static openNav() {
    this.btn.click();
  }

  static showNav(__d = 0) {
    this.navOpen = true;
    gsap.killTweensOf(this.container);

    this.container.classList.add('--navOpen');

    if (isMobile) {
      gsap.set(this.text, { opacity: 0, y: '-20%', delay: __d });

      gsap.to(this.container, {
        width: this.sizes.opened.x,
        duration: .2,
        delay: __d,
        ease: Power3.easeOut
      });

      gsap.to(this.container, {
        height: this.sizes.opened.y,
        duration: .5,
        delay: __d + .2,
        ease: Power3.easeOut
      });
    } else {
      gsap.to(this.container, {
        width: this.sizes.opened.x,
        height: this.sizes.opened.y,
        duration: .5,
        delay: __d,
        ease: Power3.easeOut
      });
    }
  }

  static hideNav(__d = 0) {
    gsap.killTweensOf(this.container);
    this.container.classList.remove('--navOpen');

    if (isMobile) {
      gsap.to(this.container, {
        height: this.sizes.closed.y,
        duration: .25,
        delay: __d,
        ease: Power3.easeOut
      });

      gsap.set(this.text, { opacity: 1, delay: __d + .25 });
      gsap.set(this.text, { y: 0, delay: __d + .25 + 0.08 });

      gsap.to(this.container, {
        width: this.sizes.closed.x,
        duration: .1,
        delay: __d + .25,
        ease: Power3.easeOut,
        onComplete: () => {
          this.navOpen = false;
          this.container.style.removeProperty('width');
          this.container.style.removeProperty('height');
        }
      });
    } else {
      gsap.to(this.container, {
        width: this.sizes.closed.x,
        height: this.sizes.closed.y,
        duration: .25,
        delay: __d,
        ease: Power3.easeOut,
        onComplete: () => {
          this.navOpen = false;
          this.container.style.removeProperty('width');
          this.container.style.removeProperty('height');
        }
      });
    }
  }

  static resize() {
    super.resize();

    this.container.style.removeProperty('width');
    this.container.style.removeProperty('height');
    this.sizes.closed = {
      x: this.container.offsetWidth,
      y: this.height
    }

    this.container.classList.add('--hover');
    this.sizes.hover = {
      x: this.container.offsetWidth,
      y: this.height
    }
    this.container.classList.remove('--hover');

    this.sizes.opened = { x: Sidemenu.sizes.x, y: Sidemenu.sizes.y };
  }
}
